import { Dispatch, SetStateAction } from "react";
import { UploadType } from "store/url-builder";
import { http } from ".";
import { ResponseProps } from "./../types/response";

export enum OTHERAPI {
  UPLOAD = "/user-file/upload",
  UPLOADEMBEDED = "/user-file/embed",
  CONFIG = "/configuration",
  EMBEDEDDETAILS = "/user-file/embed-details",
}

export const uploadContent = (
  file: File,
  setProgress?: Dispatch<SetStateAction<number>>
) => {
  const formData = new FormData();
  formData.append("file", file);

  let config = {
    onUploadProgress: (progressEvent: ProgressEvent) => {
      let percentCompleted = Math.floor(
        (progressEvent.loaded * 100) / progressEvent.total
      );
      if (setProgress) setProgress(percentCompleted);
    },
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };

  return http.post<ResponseProps>(OTHERAPI.UPLOAD, formData, config);
};

export const uploadContentEmbeded = (file: UploadType) =>
  http.post<ResponseProps>(OTHERAPI.UPLOADEMBEDED, file);

export const getConfig = () => http.get(OTHERAPI.CONFIG);

export const getEmbededDetails = (url: string) =>
  http.post<ResponseProps>(OTHERAPI.EMBEDEDDETAILS, { url });
